import {POST_ENROLLMENT} from "../../actions";

export default (state = [], action) => {
    switch (action.type) {
        case POST_ENROLLMENT:
            return action.payload;
        default:
            return state;
    }
};